import { useTranslation } from 'react-i18next';

import type { InvoiceTemplate } from '~/api/invoiceTemplates/types';

import { desktopTruncateStyle } from '~/styles/utilities.css';

import { InvoiceTemplateStatusTag } from '../../components/InvoiceTemplateStatusTag';
import { typeCellStyle } from './invoiceTemplateCell.css';

type Props = {
  invoiceTemplate: InvoiceTemplate;
};

export const InvoiceTemplateTypeCell = ({ invoiceTemplate }: Props) => {
  const { t } = useTranslation(['invoiceTemplates']);

  return (
    <div className={typeCellStyle}>
      <span className={desktopTruncateStyle}>{t(`invoiceTemplates:terminology.templateType.cases.${invoiceTemplate.type}`)}</span>

      {invoiceTemplate.intervalStatus !== null && <InvoiceTemplateStatusTag status={invoiceTemplate.intervalStatus} />}
    </div>
  );
};
